import { ItemType } from "../defines/enums"
import { Position, RenderConfig, RenderSymbol } from "../defines/types"
import { generateRandomNumber } from "../utils/rng"

export class Entity {
  public baseClass: string = "Entity"

  private _position: Position
  private _render: RenderConfig
  private _symbolIndex: number = 0

  constructor(
    position: Position,
    public blocks: boolean,
    render: RenderConfig,
    public displayName: string,
    public optic?: ItemType
  ) {
    this._position = position
    // this._render = cloneDeep(render)
    this._render = { ...render }
    this._symbolIndex = generateRandomNumber(0, render.symbol.length - 1)
  }

  get position(): Position {
    return this._position
  }

  protected render(): RenderConfig {
    return this._render
  }

  renderLight(): RenderSymbol {
    const symbol = this.nextSymbol()
    return { symbol: symbol, color: this._render.light }
  }

  renderDark(): RenderSymbol {
    const symbol = this.nextSymbol()
    return { symbol: symbol, color: this._render.dark }
  }

  private nextSymbol(): string {
    const symbol = this._render.symbol[this._symbolIndex]

    this._symbolIndex += 1
    if (this._symbolIndex >= this._render.symbol.length) {
      this._symbolIndex = 0
    }

    return symbol
  }
}
